import { render, staticRenderFns } from "./ProsList.vue?vue&type=template&id=f8c7d7ba&scoped=true&"
var script = {}
import style0 from "./ProsList.vue?vue&type=style&index=0&id=f8c7d7ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c7d7ba",
  null
  
)

export default component.exports